import { CascadiaColor } from "@certn/cascadia-tokens";
import * as React from "react";
import { RadioProps as AriaRadioProps } from "react-aria-components";

import { _Radio } from "./assets/_Radio";
import { RadioGroupContext } from "./radio-group/RadioGroup";
import { _Text } from "../../_assets/_Text";
import { Stack } from "../../../foundations/grid-layout/Stack";
import { css } from "@emotion/css";

export interface RadioProps extends Omit<AriaRadioProps, "style"> {
  children?: string | React.ReactNode;
  errorMessage?: string;
  description?: string;
  descriptionColor?: CascadiaColor;
  testID: string;
  isCard?: boolean;
  style?: "default" | "subtle";
  options?: React.JSX.Element;
}

export function Radio(props: RadioProps) {
  const {
    errorMessage,
    children,
    description,
    style: textStyle = "default",
    isCard,
    testID,
    descriptionColor = "text-weak",
    isDisabled = false,
    options,
    ...checkboxProps
  } = props;
  const { isCard: groupIsCard } = React.useContext(RadioGroupContext);

  return (
    <_Radio
      {...checkboxProps}
      isCard={isCard || groupIsCard}
      isDisabled={isDisabled}
      data-testid={testID}
    >
      {children && (
        <_Text
          style={textStyle === "subtle" ? "form/body-secondary" : "input/label"}
          color={isDisabled ? "text-disabled" : undefined}
        >
          {children}
        </_Text>
      )}
      {description && (
        <_Text style="input/helper" color={descriptionColor} slot="description">
          {props.description}
        </_Text>
      )}
      {options && <Stack className={css({ paddingTop: 8 })}>{options}</Stack>}
    </_Radio>
  );
}
